import { createSlice } from "@reduxjs/toolkit"
import { createActions } from "@helper"
import * as actions from '../action'

const initialState = {
    params: {
        type: 1,
        conditionContent: ''
    },
    page: {
        pageNum: 1,
        pageSize: 20,
        total: 0
    },
    lCheckList: []
}

const reducer = createActions({
    setParams: (state, action) => {
        const { params, ...other} = state
        return { ...other, params: {...params, ...action.payload}}
    },
    queryKnowledgeReviewPageAction: {
       pending: (state, action) => {
            const { meta: { arg } } = action
            const { pageNum, pageSize, ...otherParams } = arg || {}
 
             return {
                 ...state,
                 params: {...otherParams},
                 page: {...state.page, pageNum, pageSize}
             }
         },
        success: (state, action) => {
            const { total, list } = action.payload
            return {
                ...state,
                page: { ... state.page, total },
                lCheckList: list
            }
        } 
    }
}, actions)

const lcheckSlice = createSlice({
    name: 'lcheck',
    initialState,
    ...reducer
})

export const getParams = (state) => state.lcheck.params
export const getPage = (state) => state.lcheck.page
export const getLCheckList = (state) => state.lcheck.lCheckList

export const {setParams} = lcheckSlice.actions
export default lcheckSlice
